var $ = require('jquery');

function ourProcessSlider() {
	if ($(window).width() >= 1279) {
		console.log($(window).width());
		var descriptions = $('.our-process .process-item-description');
		var maxHeight = 0;
		$('.our-process .process-item-description').each(function () {
			if ($(this).height() > maxHeight) {
				maxHeight = $(this).height();
			}
		});
		descriptions.height(maxHeight);
		descriptions.hide();
		descriptions.first().show();
		$('.our-process .process-item').first().addClass('active');
		$('.items-wrap').addClass('active0');
		$('.our-process .process-item').each(function (index) {
			$(this).on('click', function () {
				$(this).find('.process-item-description').show();
				$('.our-process .process-item').not(this).find('.process-item-description').hide();
				$('.our-process .process-item').not(this).removeClass('active');
				$(this).addClass('active');
				$('.items-wrap').removeClass('active0 active1 active2 active3 active4 active5 active6 active7 active8 active9');
				$('.items-wrap').addClass('active' + index);
			});
		});

		$('.arrow-left').on('click', function () {
			var active = $('.our-process .process-item.active');
			var prev = active.prev();
			if (prev.length === 0) {
				prev = $('.our-process .process-item').last();
			}
			prev.find('.process-item-description').show();
			$('.our-process .process-item').not(prev).find('.process-item-description').hide();
			$('.our-process .process-item').not(prev).removeClass('active');
			prev.addClass('active');
			var index = $('.our-process .process-item').index(prev);
			$('.items-wrap').removeClass(function (index, className) {
				return (className.match(/(^|\s)active\d+/g) || []).join(' ');
			}).addClass('active' + index);
		});

		$('.arrow-right').on('click', function () {
			var active = $('.our-process .process-item.active');
			var next = active.next();
			if (next.length === 0) {
				next = $('.our-process .process-item').first();
			}
			next.find('.process-item-description').show();
			$('.our-process .process-item').not(next).find('.process-item-description').hide();
			$('.our-process .process-item').not(next).removeClass('active');
			next.addClass('active');
			var index = $('.our-process .process-item').index(next);
			$('.items-wrap').removeClass(function (index, className) {
				return (className.match(/(^|\s)active\d+/g) || []).join(' ');
			}).addClass('active' + index);
		});
	} else {
		$('.our-process .process-item-description').each(function () {
			$(this).css('height', 'auto');
			$(this).show();
		});
		$('.our-process .process-item').each(function (index) {
			$(this).off('click');
			$(this).removeClass('active');
		});
	}
}

$(document).ready(function () {
	ourProcessSlider();
});

$(window).resize(function () {
	ourProcessSlider();
});